import { useMutation, useQueryClient } from '@tanstack/react-query';
import { custonSooner } from '../../../components/CustopmSooner';
import { addressesAPI } from '../api/address';
import { captureApiError } from '../../../lib/sentry-utils';

export const useDeleteAddress = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (id: string) => await addressesAPI.deleteAddress(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['addresses'] });
      custonSooner.success('Адрес успешно удален!', true);
    },
    onError: (error: any) => {
      console.error('DeleteAddress error:', JSON.stringify(error, Object.getOwnPropertyNames(error), 2));
      captureApiError(error, '/api/addresses/delete', 'DELETE');
      custonSooner.error(error?.response?.data?.message || error?.message || 'Что-то пошло не так');
    },
  });
  return {
    deleteAddress: mutateAsync,
    isPending,
  };
};
